import { FC } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { ContentLayout } from 'components/Layouts'
import { BackToPremiumsBreadcrumb } from 'containers/Premiums/components/BackToPremiumsBreadcrumb'
import { Alert } from '@cmsgov/ds-medicare-gov'
import { MyInternalLink } from 'components/MyLink'
import { PaymentDetailsCard } from '../../components/PaymentDetailsCard/PaymentDetailsCard'
import { useQueryParams } from 'hooks/useQueryParams'
import { Component } from '@cms-max/medicare-api-sdk'

function PaymentHistoryLink ({ children }: {children?: React.ReactNode}) {
  return <MyInternalLink to="/premiums/history">{children}</MyInternalLink>
}

export const MakeAPaymentSubmittedPage: FC = () => {
  const { t } = useTranslation('makeAPaymentSubmittedPage')
  const queryParams = useQueryParams()
  const agencyTrackingId = queryParams.get('agencyTrackingId') || ''
  const tcsAppId = queryParams.get('tcsAppId') || ''

  return (
    <ContentLayout
      className="ds-u-padding-bottom--7"
      heading={t('heading')}
      width="wide"
      withPrintButton
      nav={<BackToPremiumsBreadcrumb />}
      printComponent={Component.Premiums}
    >
      <div className='ds-l-container'>
        <Alert variation='success' className='ds-u-measure--wide'>
          <Trans t={t} i18nKey={'submittedMessage'} components={{
            link1: <PaymentHistoryLink />
          }} />
        </Alert>
        {(agencyTrackingId && tcsAppId) && (
          <PaymentDetailsCard agencyTrackingId={agencyTrackingId} appId={tcsAppId} />
        )}
        <MyInternalLink to="/premiums" className="ds-c-button ds-c-button--alternate ds-c-button--solid ds-u-margin-top--5">
          {t('backToPremiumsButton')}
        </MyInternalLink>
      </div>
    </ContentLayout>
  )
}
